export default __webpack_public_path__ + "static/media/icon-file-csv.1f066c19.svg";